<sales-error
  [contactHelpNumber]="'0800 597 8588'"
  [home]="'https://www.ao-care.com/'"
  [faq]="'https://www.ao-care.com/content/ao-care-help-advice/ao-faqs'"
  [contact]="'https://www.ao-care.com/content/contact-us'"
></sales-error>
